import { useAuth0 } from '@auth0/auth0-react'
import { Box, Button } from '@mui/material'
import React from 'react'

const UnauthenticatedView = () => {
  const { loginWithRedirect } = useAuth0()
  return (
    <Box display='flex' flexDirection='column' alignItems='center' sx={{
      margin: '0px auto',
      border: 1,
      borderColor: 'primary.main',
      width: '30%',
      minWidth: '320px',
      padding: 2,
      borderRadius: '12px',
      marginTop: '100px'
    }}>
      <Box sx={{
        padding: '16px',
        width: '90%'
      }}>
        <img src='ecliptic-nav-logo-light.svg' alt='Ecliptic Capital' style={{
          width: '100%'
        }} />
      </Box>
      <Button variant='contained' onClick={() => {
        loginWithRedirect()
      }}>
        Sign In
      </Button>
    </Box>
  )
}

export default UnauthenticatedView
